import { useRequest } from 'ahooks'
import { createStyles } from 'antd-style'

import { queryTransactionDynamicsApi } from '@eastcoal/api/trade/orderMember/queryTransactionDynamics'

import { AutoScroll } from '@eastcoal/common/components/AutoScroll'
import { formatDate } from '@eastcoal/common/utils/date'
import { pretty } from '@eastcoal/common/utils/decimal'

import { BizType } from '@eastcoal/shared/enums/BizType'

const useStyles = createStyles(({ token, prefixCls }) => ({
  container: {
    paddingInline: token.padding,
    paddingBlock: token.paddingSM,
    maxHeight: 134
  },
  title: {
    marginBlockEnd: token.marginXXS,
    color: token.colorPrimaryText,
    fontSize: token.fontSizeHeading5
  },
  item: {
    display: 'grid',
    gridTemplateColumns: '60px 200px 1fr auto auto',
    alignItems: 'center',
    columnGap: token.marginMD,
    lineHeight: 1,
    paddingBlock: token.paddingXS
  },
  tag: {
    paddingInline: token.paddingXXS,
    paddingBlock: 2,
    fontSize: token.fontSizeSM,
    border: `1px solid currentColor`,
    borderRadius: token.borderRadiusXS
  },
  date: {
    color: token.colorTextTertiary
  }
}))

const BizTypeTextMap = {
  [BizType.TRADITION_AUCTION]: '竞价',
  [BizType.RANKING_AUCTION]: '竞价',
  [BizType.HOUSE_AUCTION]: '竞价',
  [BizType.INQUIRY_AUCTION]: '询比价',
  [BizType.TENDER_AUCTION]: '招标',
  [BizType.SECRET_AUCTION]: '密函',
  [BizType.PRICE_CUT_AUCTION]: '减价',
  [BizType.PRICE_COMPARE]: '比价采购',
  [BizType.LISTING]: '挂牌',
  [BizType.ACCOUNT]: 'NA'
}

export const OrderList = () => {
  const { data } = useRequest(
    () => queryTransactionDynamicsApi(undefined, { silence: true }),
    {
      manual: false
    }
  )

  const { theme, styles } = useStyles()

  const BizTypeColorMap = {
    [BizType.TRADITION_AUCTION]: theme.colorPrimary,
    [BizType.RANKING_AUCTION]: theme.colorPrimary,
    [BizType.HOUSE_AUCTION]: theme.colorPrimary,
    [BizType.INQUIRY_AUCTION]: theme.colorPrimary,
    [BizType.TENDER_AUCTION]: theme.colorPrimary,
    [BizType.SECRET_AUCTION]: theme.colorPrimary,
    [BizType.PRICE_CUT_AUCTION]: theme.colorPrimary,
    [BizType.PRICE_COMPARE]: theme.colorPrimary,
    [BizType.LISTING]: theme.volcano,
    [BizType.ACCOUNT]: theme.volcano
  }

  return (
    <div className={styles.container}>
      <div className={styles.title}>交易动态</div>
      <AutoScroll orientation='vertical'>
        {data?.map(
          (
            { bizType = 0, dealQuantity, dealDate, kindName, memberName, unit },
            index
          ) => (
            <div key={index} className={styles.item}>
              <div>
                <span
                  className={styles.tag}
                  style={{ color: BizTypeColorMap[bizType] }}
                >
                  {BizTypeTextMap[bizType]}
                </span>
              </div>

              <div>
                <span>{memberName}</span>
              </div>
              <span>{kindName}</span>
              <span>
                {pretty(dealQuantity)}
                {unit}
              </span>
              <span className={styles.date}>
                {formatDate(dealDate, 'MM-DD')}
              </span>
            </div>
          )
        )}
      </AutoScroll>
    </div>
  )
}
